import { ContextStore } from '../stores';

export const initAppendContextData =
  (store: ContextStore) =>
  <TInput>(input: TInput): TInput => {
    const { sessionId, organisationId, pageCorrelationId, isReturningUser } = store.getContext();
    return {
      ...input,
      isReturningUser,
      sessionId,
      organisationId,
      pageCorrelationId,
    };
  };
